import { ref, reactive, watch } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-36feffaf"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "over-sea-content"
};
const _hoisted_2 = {
  class: "flex-content"
};
const __default__ = {
  name: 'Aptoide'
};
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    rules: {},
    detailForm: {}
  },
  emits: ['submitForm', 'setVisible'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const divideList = ref([]); // 分成比例
    const aptoideRef = ref(null); // Aptoide支付ref
    const aptoideForm = reactive({
      divide: '',
      pkg: ''
    }); // Aptoide支付
    const validateForm = () => {
      var _aptoideRef$value;
      (_aptoideRef$value = aptoideRef.value) === null || _aptoideRef$value === void 0 || _aptoideRef$value.validate().then(() => {
        emit('submitForm', aptoideForm);
      }).catch(e => void 0);
    };
    watch(() => props.detailForm, n => {
      if (n) {
        aptoideForm.pkg = n.pkg;
        aptoideForm.divide = n.divide;
        aptoideForm.id = n.id;
        divideList.value = n.rateList;
      }
    }, {
      immediate: true,
      deep: true
    });
    expose({
      validateForm
    });
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_form = _resolveComponent("a-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_form, {
        model: aptoideForm,
        ref_key: "aptoideRef",
        ref: aptoideRef,
        rules: __props.rules,
        name: "aptoide-validate"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form_item, {
          name: "pkg",
          label: "包名："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: aptoideForm.pkg,
            "onUpdate:value": _cache[0] || (_cache[0] = $event => aptoideForm.pkg = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "divide",
          label: "分成比例："
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_select, {
            value: aptoideForm.divide,
            "onUpdate:value": _cache[1] || (_cache[1] = $event => aptoideForm.divide = $event),
            options: divideList.value
          }, null, 8, ["value", "options"])])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "rules"])]);
    };
  }
});